import { render, staticRenderFns } from "./MatInventory.vue?vue&type=template&id=4a15bb64&scoped=true&"
import script from "./MatInventory.vue?vue&type=script&lang=ts&"
export * from "./MatInventory.vue?vue&type=script&lang=ts&"
import style0 from "./MatInventory.vue?vue&type=style&index=0&id=4a15bb64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15bb64",
  null
  
)

export default component.exports